import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import InquiryContent from './components/InquiryContent';

export default function InquiryPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '立即諮詢｜保健食品 ODM OEM 代工洽詢｜康永生技',
    description: '立即與康永生技洽詢保健食品 ODM/OEM 代工需求：專人1個工作天內回覆，協助評估最適合的合作模式與代工方案。',
    keywords: '立即諮詢,代工洽詢,ODM諮詢,OEM諮詢,保健食品代工詢價',
    lang: 'zh-TW',
    canonicalPath: '/cooperation/inquiry',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="立即諮詢｜保健食品 ODM OEM 代工洽詢｜康永生技" pageDescription="立即與康永生技洽詢保健食品 ODM/OEM 代工需求：專人1個工作天內回覆，協助評估最適合的合作模式與代工方案。" pageUrl={`${siteUrl}/cooperation/inquiry`} />
      <InquiryContent />
    </Layout>
  );
}